import React, { useMemo } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import { AppProvider } from './context/AppContext';
import { useActiveSection } from './hooks/useActiveSection';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './sections/About';
import Projects from './components/Projects';
import Certificates from './components/Certificates';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BlogListPage from './pages/BlogListPage';
import BlogPostPage from './pages/BlogPostPage';
import CursorGlow from './components/CursorGlow';

function PortfolioHome() {
  const sectionIds = useMemo(
    () => ['hero', 'about', 'projects', 'certificates', 'contact'],
    []
  );
  useActiveSection(sectionIds);

  return (
    <div className="App">
      <CursorGlow />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Projects />
        <Certificates />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortfolioHome />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />
          {/*<Route path="/diagrams" element={<DiagramsPage />} />*/}
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
